import { LayoutList } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ppcOfferingsSection: ServiceSection = {
  type: SECTION_TYPES.PPC_OFFERINGS,
  content: {
    header: "What We Do",
  },
  meta: {
    displayName: "Offerings PPC",
    displayDescription: "Highlight the services you offer.",
    displayIcon: LayoutList,
  },
};

export default ppcOfferingsSection;
